const decodeEmbedding = (encoded) => {
    if (!encoded)
        return undefined;
    try {
        const binary = atob(encoded);
        const bytes = new Uint8Array(binary.length);
        for (let i = 0; i < binary.length; i += 1) {
            bytes[i] = binary.charCodeAt(i);
        }
        return Array.from(new Float32Array(bytes.buffer));
    }
    catch (error) {
        console.error('Failed to decode clause embedding; skipping similarity for it', error);
        return undefined;
    }
};
export default decodeEmbedding;
